import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FiLinkedin } from "../assets/icons/vander";
import useStore from "../store/useStore";

export default function Team() {
  const { nosotrosTeams, getNosotrosTeams } = useStore();
  useEffect(() => {
    getNosotrosTeams();
  }, [getNosotrosTeams]);

  return (
    <>
      <div className="w-full  bg-sidom-blue mb-[100px]">
        <div className="container">
          <div className="grid grid-cols-1 text-center">
            <h3 className=" text-4xl md:text-5xl mt-[100px]  text-sidom-orange font-bold mb-[60px] text-left">
              Conozca a nuestro Team
            </h3>
          </div>

          <div className="grid md:grid-cols-12 grid-cols-1 mt-6  gap-6">
            {nosotrosTeams?.map((item, index) => {
              return (
                <div
                  className="lg:col-span-3 md:col-span-6 text-sidom-light mb-[100px]"
                  key={index}
                >
                  <div className="group text-center">
                    <div className="relative inline-block mx-auto h-52 w-52 rounded-full overflow-hidden">
                      <img
                        src={`https://api.institucional.global.sidom.io${item.img[0].formats.thumbnail.url}`}
                        className="object-cover w-full h-full "
                        alt={item.nombre}
                      />

                      <ul className="list-none absolute top-1/2 -translate-y-1/2 -end-20 group-hover:end-5 transition-all duration-500 ease-in-out">
                        <li className="mt-1">
                          <a
                            href={item.url[0].children[1].children[0].text}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="h-8 w-8 inline-flex items-center text-center justify-center text-base font-normal tracking-wide border align-middle transition duration-500 ease-in-out rounded-full bg-orange-500 hover:bg-orange-600 border-orange-500 hover:border-orange-600 text-white"
                          >
                            <FiLinkedin className="h-4 w-4" />
                          </a>
                        </li>
                      </ul>
                    </div>

                    <div className="content mt-3">
                      <Link
                        to=""
                        className="text-lg font-medium text-orange-500 duration-500"
                      >
                        {item.nombre}
                      </Link>
                      <p className="">{item.cargo}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}
